"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.register_events = void 0;
var utils_1 = require("./utils/utils");
function register_events() {
    document.addEventListener('click', select_event);
}
exports.register_events = register_events;
/**
 * @param event
 */
function select_event(event) {
    if (!(event.target instanceof HTMLElement))
        return;
    var selectable_el = (0, utils_1.get_parent_element_by_condition)(event.target, function (element) { return element.getAttribute('data-selectable') === "true"; });
    if (!selectable_el)
        return;
    var selected_event = new CustomEvent('lgm.selected', {
        detail: {
            element: selectable_el
        }
    });
    document.dispatchEvent(selected_event);
}
